import { NgModule } from '@angular/core';
import { PriceModule } from '@icc/price';
import { PricePleatedBlindService } from './price-pleated-blind.service';

@NgModule({
    imports: [PriceModule],
    providers: [PricePleatedBlindService],
})
export class PleatedBlindPriceModule {}
